import { Component, OnInit, Input, DoCheck } from '@angular/core';
import { IContentElementImage } from '../models';
import {BrowserModule, DomSanitizer, SafeResourceUrl} from '@angular/platform-browser'
@Component({
  selector: 'render-image',
  templateUrl: './render-image.component.html',
  styleUrls: ['./render-image.component.scss']
})
export class RenderImageComponent implements OnInit, DoCheck {

  @Input() element:IContentElementImage;

  urlRaw:string;
  url:SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.updateUrl();
  }

  ngDoCheck() {
    this.updateUrl();
  }

  updateUrl(){
    if (this.urlRaw !== this.element.url){
      this.urlRaw = this.element.url;
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlRaw);
    }
  }

  getImageUrl(){
    return this.url;
  }

}
